module.exports = "//public.getcloudapp.com/packs/media/images/view-list-active-25ca10080571f6a7440490e12a51494e.svg";